<template>
  <div class="box-tab">
    <div id="accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES72UC4']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.desc_codrel }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.namsick }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block-float detail-block-left">
                <div class="detail-header">{{ labels['HRES72UC4']['50'] }}</div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.desc_codcln }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['80'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.desc_coddc }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['240'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.desc_typpatient }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['90'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.desc_typamt }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['100'] }}</div>
                  <div class="detail-right">
                    <input type="radio" value="Y" v-model="detail.tab1.flgdocmt" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC4']['110'] }}</span>
                    <input type="radio" value="N" v-model="detail.tab1.flgdocmt" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC4']['120'] }}</span>

                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['130'] }}</div>
                  <div class="detail-right">
                      <!-- <div class="detail-text width-70"><a :href="detail.tab1.path_filenam1" target="_blank">{{ detail.tab1.filenam1 }}</a></div> -->
                    <div class="detail-text width-70"><a :href="baseURL + detail.tab1.path_filenam1" target="_blank">{{ detail.tab1.filenam1 }}</a></div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['140'] }}</div>
                  <div class="detail-right">
                      <!-- <div class="detail-text width-70"><a :href="detail.tab1.path_filenam2" target="_blank">{{ detail.tab1.filenam2 }}</a></div> -->
                    <div class="detail-text width-70"><a :href="baseURL + detail.tab1.path_filenam2" target="_blank">{{ detail.tab1.filenam2 }}</a></div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['150'] }}</div>
                  <div class="detail-right">
                      <!-- <div class="detail-text width-70"><a :href="detail.tab1.path_filenam3" target="_blank">{{ detail.tab1.filenam3 }}</a></div> -->
                    <div class="detail-text width-70"><a :href="baseURL + detail.tab1.path_filenam3" target="_blank">{{ detail.tab1.filenam3 }}</a></div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['160'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.amtreq }}</div>
                  </div>
                </div>
              </div>


              <div class="detail-block-float detail-block-right">
                <div class="detail-header">{{ labels['HRES72UC4']['60'] }}</div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['170'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ setDateOutput(detail.tab1.dtecrest) }} - {{ setDateOutput(detail.tab1.dtecreen) }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['180'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.qtydte }}</div>
                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['190'] }}</div>
                  <div class="detail-right">

                    <input type="radio" value="1" v-model="detail.tab1.typpay" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC4']['200'] }}</span>
                    <input type="radio" value="2" v-model="detail.tab1.typpay" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC4']['210'] }}</span>

                  </div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES72UC4']['220'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.remarkap }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES72UC0']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">

            <hrms-table :columns="tab2Table" :data="detail.tab2.table" :columnEvent="columnEvent" :summaryLabel="labels['HRES72UC0']['70']" />
            <input data-toggle="modal" data-target="#hres72u-popup" ref="popup" type="hidden"/>
            <popup :labels="labels"
                    :nowLang="nowLang"
                    :detailTab2Popup="detailTab2Popup"
                    v-show="popupDisp" />

          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES72UC5']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['10'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70 txtarea-width response-full-width">{{ detail.tab3.syncond }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['20'] }}</div>
                <div class="detail-right">

                  <input type="radio" value="Y" v-model="detail.tab3.flgprorate" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC5']['30'] }}</span>
                  <input type="radio" value="N" v-model="detail.tab3.flgprorate" disabled="disabled" /> <span class="radio-text">{{ labels['HRES72UC5']['40'] }}</span>

                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['50'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.desc_typamt }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['60'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.amtwidrwy }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['70'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.qtysum }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['80'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.amtalw }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['90'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.qtywidrwy }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES72UC5']['100'] }}</div>
                <div class="detail-right">
                  <div class="detail-text width-70">{{ detail.tab3.amtwidrwt }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="box-footer">
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import env from 'src/../env.js'
import popup from 'components/hres72u/popup'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres72u-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'codempid', 'toggle', 'tab2Table', 'nowLang', 'receivedHres72uDetailTab2Popup', 'detailTab2Popup' ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  methods: {
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'descCoddcal':
          let popupParams = param
          this.receivedHres72uDetailTab2Popup(popupParams)
          this.$refs.popup.click()
          break
      }
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    popup
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?59356199